import React from 'react';
import { useDataContext } from '../../core/context/DataContext';

const DataLoader: React.FC = () => {
  const { loading } = useDataContext();

  if (!loading) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50">
      <div className="flex flex-col items-center">
        {/* Logo centrado arriba */}
        <img src="/assets/logo/logo.png" alt="Logo" className="w-96 h-auto mb-4" />
        {/* Spinner blanco debajo */}
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-white mt-8"></div>
      </div>
    </div>
  );
};

export default DataLoader;
